// extracted by css-extract-rspack-plugin
export default {"ellipsisMenuButton":"hgLaZ","ellipsisMenuButtonFloating":"Q3Kng","ellipsisMenuButtonInline":"ghBB1"};